import { FieldValues } from 'react-hook-form'
import { editEntityDataEmbeddedAPI } from '../apis/entityData.api'
import { ENTITY_NAME, NAMESPACES } from './constants'

export const updateInteractionStatus = async (
  communicationId: string,
  statusId: number
) => {
  try {
    await editEntityDataEmbeddedAPI(
      ENTITY_NAME.COMMUNICATION,
      communicationId as string,
      {
        id: communicationId,
        category_status: {
          id: statusId,
          _state: NAMESPACES.CHANGED,
        },
      },
      ['category_status']
    )
  } catch (err) {
    console.error(err)
  }
}

export const formatDuration = (seconds: number) => {
  const mins = String(Math.floor(seconds / 60)).padStart(2, '0')
  const secs = (seconds % 60).toFixed(0).padStart(2, '0')
  return `${mins}:${secs}`
}

export const isMultipleRecords = (data: FieldValues) => {
  const entityKeys = Object.keys(data)
  if (entityKeys?.length > 1) {
    return true
  }
  const entity = data[entityKeys[0]]
  if (!entity?.records || entity?.records?.length !== 1) {
    return true
  }
  if (entity?.records.length) {
    return true
  } else {
    return false
  }
}
